import { VREditorSubPanel } from './subpanel.js';
import { Button, FieldLabel } from '../../../ui/2.0/ca-ui';

export class VREditorBoardPanel extends VREditorSubPanel {
  constructor (vr, editor) {
    super(vr, editor, {
      id: 'boards',
      name: 'Display Boards',
      instructions: 'Select a board to edit, or add a new board.',
      preview: true,
      assets: vr.assets.boards,
      assetSelectLabel: 'Type',
      addApplyAssetButton: true,
      addApplyAssetMessage: '',
      allowAddAsset: true,
      addAssetButtonLabel: 'New Board',
      onAssetSwitch: function (asset) {
        console.log('on asset switch');
        console.log(asset);
        if (this.getObject()) {
          this.getObject().setAsset(asset);
          this.selected.initBoardImageContainers();
          this.selected.setHeadingText(asset.name);
        }
      },
      onAssetChange: function (asset) {
        if (this.getObject()) {
          this.getObject().setAsset(asset);
          this.setObject(this.getObject(), false);
        }
        this.preview.css(
          'background-image',
          'url(https://ca-v2.s3.ap-southeast-2.amazonaws.com/ca/virtual-editor/assets/boards/board_' +
            asset.id +
            '_day.png)'
        );
      },
      onCreateAssetItem: function (item, asset) {
        item.css(
          'background-image',
          'url(https://ca-v2.s3.ap-southeast-2.amazonaws.com/ca/virtual-editor/assets/boards/board_' +
            asset.id +
            '_day.png)'
        );
      }
    });
  }

  initControls () {
    // Media - for single image boards
    this.singleMediaContainer = new FieldLabel({ label: 'Media' });
    this.singleMediaContainer.el.css('margin-top', '20px');
    this.singleMediaContainer.hide();
    super.append(this.singleMediaContainer.el);

    this.chooseMediaButton = new Button({
      icon: 'photo-video',
      label: 'Change'
    });
    this.chooseMediaButton.on(
      'click',
      function () {
        console.log('fired by choose media single button');
        this.vr.editor.openMediaPicker((data) => this.setMedia(data));
      }.bind(this)
    );
    this.singleMediaContainer.setField(this.chooseMediaButton);

    // Size - for single image
    this.singleImageSizeContainer = new FieldLabel({ label: 'Media size' });
    this.singleImageSizeContainer.hide();
    super.append(this.singleImageSizeContainer.el);

    this.singleImageSizeSlider = $(
      '<input class="ca-vr_editorpanel-range" type="range" min="50" max="400" value="100"></input>'
    );

    this.singleImageSizeSlider.on(
      'input',
      function () {
        this.selected.setImageSize(this.singleImageSizeSlider.val());
      }.bind(this)
    );

    this.singleImageSizeContainer.setField(this.singleImageSizeSlider);

    // media for map table - map image
    this.mapImageMediaContainer = new FieldLabel({ label: 'Map Image' });
    this.mapImageMediaContainer.el.css('margin-top', '20px');
    this.mapImageMediaContainer.hide();
    super.append(this.mapImageMediaContainer.el);

    this.chooseMapImageButton = new Button({
      icon: 'photo-video',
      label: 'Change'
    });
    this.chooseMapImageButton.on(
      'click',
      function () {
        console.log('fired by choose media map button button');
        this.vr.editor.openMediaPicker((data) => this.setMedia(data, 0));
      }.bind(this)
    );
    this.mapImageMediaContainer.setField(this.chooseMapImageButton);

    // size - for map image
    this.mapImageSizeContainer = new FieldLabel({ label: 'Media size' });
    this.mapImageSizeContainer.hide();
    super.append(this.mapImageSizeContainer.el);

    this.mapImageSizeSlider = $(
      '<input class="ca-vr_editorpanel-range" type="range" min="50" max="400" value="100"></input>'
    );

    this.mapImageSizeSlider.on(
      'input',
      function () {
        this.selected.setImageSize(this.mapImageSizeSlider.val(), 0);
      }.bind(this)
    );

    this.mapImageSizeContainer.setField(this.mapImageSizeSlider);

    // media for map table - document 1
    this.document1MediaContainer = new FieldLabel({ label: 'Document 1 Image' });
    this.document1MediaContainer.el.css('margin-top', '20px');
    this.document1MediaContainer.hide();
    super.append(this.document1MediaContainer.el);

    this.chooseDocument1ImageButton = new Button({
      icon: 'photo-video',
      label: 'Change'
    });
    this.chooseDocument1ImageButton.on(
      'click',
      function () {
        console.log('fired by choose media document 1 button');
        this.vr.editor.openMediaPicker((data) => this.setMedia(data, 1));
      }.bind(this)
    );
    this.document1MediaContainer.setField(this.chooseDocument1ImageButton);

    // size - for document 2 image
    this.document1SizeContainer = new FieldLabel({ label: 'Media size' });
    this.document1SizeContainer.hide();
    super.append(this.document1SizeContainer.el);

    this.document1SizeSlider = $(
      '<input class="ca-vr_editorpanel-range" type="range" min="50" max="400" value="100"></input>'
    );

    this.document1SizeSlider.on(
      'input',
      function () {
        this.selected.setImageSize(this.document1SizeSlider.val(), 1);
      }.bind(this)
    );

    this.document1SizeContainer.setField(this.document1SizeSlider);

    // media for map table - document 2
    this.document2MediaContainer = new FieldLabel({ label: 'Document 2 Image' });
    this.document2MediaContainer.el.css('margin-top', '20px');
    this.document2MediaContainer.hide();
    super.append(this.document2MediaContainer.el);

    this.chooseDocument2ImageButton = new Button({
      icon: 'photo-video',
      label: 'Change'
    });
    this.chooseDocument2ImageButton.on(
      'click',
      function () {
        console.log('fired by choose media doc 2 button');
        this.vr.editor.openMediaPicker((data) => this.setMedia(data, 2));
      }.bind(this)
    );
    this.document2MediaContainer.setField(this.chooseDocument2ImageButton);

    // size - for document 2
    this.document2SizeContainer = new FieldLabel({ label: 'Media size' });
    this.document2SizeContainer.hide();
    super.append(this.document2SizeContainer.el);

    this.document2SizeSlider = $(
      '<input class="ca-vr_editorpanel-range" type="range" min="50" max="400" value="100"></input>'
    );

    this.document2SizeSlider.on(
      'input',
      function () {
        this.selected.setImageSize(this.document2SizeSlider.val(), 2);
      }.bind(this)
    );

    this.document2SizeContainer.setField(this.document2SizeSlider);

    // media for map table - document 3
    this.document3MediaContainer = new FieldLabel({ label: 'Document 3 Image' });
    this.document3MediaContainer.el.css('margin-top', '20px');
    this.document3MediaContainer.hide();
    super.append(this.document3MediaContainer.el);

    this.chooseDocument3ImageButton = new Button({
      icon: 'photo-video',
      label: 'Change'
    });
    this.chooseDocument3ImageButton.on(
      'click',
      function () {
        console.log('fired by choose media doc 3 button');
        this.vr.editor.openMediaPicker((data) => this.setMedia(data, 3));
      }.bind(this)
    );
    this.document3MediaContainer.setField(this.chooseDocument3ImageButton);

    // size - for document 3 image
    this.document3SizeContainer = new FieldLabel({ label: 'Media size' });
    this.document3SizeContainer.hide();
    super.append(this.document3SizeContainer.el);

    this.document3SizeSlider = $(
      '<input class="ca-vr_editorpanel-range" type="range" min="50" max="400" value="100"></input>'
    );

    this.document3SizeSlider.on(
      'input',
      function () {
        this.selected.setImageSize(this.document3SizeSlider.val(), 3);
      }.bind(this)
    );

    this.document3SizeContainer.setField(this.document3SizeSlider);

    // Heading
    this.headingLabel = $('<label style="margin-top:20px">Heading</label>');
    this.headingLabel.hide();
    super.append(this.headingLabel);

    this.headingTextbox = $('<input type="input" maxlength="30" />');
    this.headingTextbox.hide();
    this.headingTextbox.on(
      'input',
      function () {
        this.selected.setHeadingText(this.headingTextbox.val());
      }.bind(this)
    );
    super.append(this.headingTextbox);

    this.hideHeadingContainer = new FieldLabel({ label: 'Hide Heading' });
    this.hideHeadingContainer.hide();
    super.append(this.hideHeadingContainer.el);

    this.hideHeadingCheckbox = $('<input type="checkbox">');
    this.hideHeadingCheckbox.hide();
    this.hideHeadingCheckbox.on('change', function () {
      this.selected.toggleHeading(this.hideHeadingCheckbox.is(':checked'));
    }.bind(this));
    super.append(this.hideHeadingCheckbox);
  }

  newObject () {
    return this.vr.addBoard();
  }

  setObject (obj, fireAssetChange) {
    super.setObject(obj, fireAssetChange);
    if (obj) {
      this.headingLabel.toggle(obj.asset && obj.asset.allowHeading);
      this.headingTextbox.toggle(obj.asset && obj.asset.allowHeading);
      if (obj.asset.id === 'maptable') {
        this.singleMediaContainer.hide();
        this.singleImageSizeContainer.hide();
        this.mapImageMediaContainer.toggle(obj.asset && obj.asset.allowMedia);
        this.document1MediaContainer.toggle(obj.asset && obj.asset.allowMedia);
        this.document2MediaContainer.toggle(obj.asset && obj.asset.allowMedia);
        this.document3MediaContainer.toggle(obj.asset && obj.asset.allowMedia);
        this.mapImageSizeContainer.toggle(obj.asset && obj.asset.allowMedia);
        this.document1SizeContainer.toggle(obj.asset && obj.asset.allowMedia);
        this.document2SizeContainer.toggle(obj.asset && obj.asset.allowMedia);
        this.document3SizeContainer.toggle(obj.asset && obj.asset.allowMedia);
      } else {
        this.singleMediaContainer.toggle(obj.asset && obj.asset.allowMedia);
        this.singleImageSizeContainer.toggle(obj.asset && obj.asset.allowMedia);
      }

      this.headingTextbox.val(obj.getHeadingText());
      this.hideHeadingContainer.toggle(obj.asset && obj.asset.allowMedia);
      this.hideHeadingCheckbox.toggle(obj.asset && obj.asset.allowMedia);
      this.hideHeadingCheckbox.prop('checked', obj.isHeadingHidden());
      if (fireAssetChange !== false) { this.assetSelect.val(obj.getPropId()).trigger('change'); }
      // this.autoAddButton.hide();
    } else {
      this.singleImageSizeContainer.hide();
      this.mapImageSizeContainer.hide();
      this.document1SizeContainer.hide();
      this.document2SizeContainer.hide();
      this.document3SizeContainer.hide();
      this.headingLabel.hide();
      this.headingTextbox.hide();
      this.mapImageMediaContainer.hide();
      this.document1MediaContainer.hide();
      this.document2MediaContainer.hide();
      this.document3MediaContainer.hide();
      this.singleMediaContainer.hide();
      this.hideHeadingContainer.hide();
      this.hideHeadingCheckbox.hide();
      // this.autoAddButton.show();
    }
  }

  openPanel() {}

  setMedia (data, index) {
    console.log('should fire ONLY once from the button click. from the board panel');
    console.log(index);
    if (data.data) {
      this.getObject().setMedia(data.data.url, data.data.type, index);
    } else {
      this.getObject().setMedia(data.url, data.type, index);
    }
  }
}
